import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import LinerChart from '../chartWidget/LinerChart/LinerChart';
import Actions from './components/Actions';
import getOrderStatistic from '../../thunks/statistic/getOrderStatistic';

const OrderChartWidget = () => {
  const dispatch = useDispatch();
  const { getOrderStatisticData, loading } = useSelector((state) => ({
    getOrderStatisticData: state.getOrderStatistic?.data,
    loading: state.getOrderStatistic?.loading,
  }), shallowEqual);

  useEffect(() => {
    dispatch(getOrderStatistic());
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        grid: {
          drawTicks: false,
        },
        border: {
          dash: [4, 4],
          display: false
        },
      },
      x: {
        grid: {
          display: false
        },
        border: {
          display: false
        }
      }
    }
  };

  return (
    <LinerChart
      data={getOrderStatisticData || {}}
      loading={loading}
      options={options}
      title="Orders"
      actions={<Actions />}
      styleContainer="w-full"
    />
  );
};

OrderChartWidget.propTypes = {};

OrderChartWidget.defaultProps = {};

export default OrderChartWidget;
